import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";

export default function LanguageSwitcher({ className = "" }) {
  const { i18n, t } = useTranslation();
  const current = (i18n.language || "en").startsWith("de") ? "de" : "en";

  const change = (lng) => {
    i18n.changeLanguage(lng);
    try {
      localStorage.setItem("elastoai_lang", lng);
    } catch (e) {
      /* ignore */
    }
  };

  return (
    <div className={`inline-flex items-center gap-1.5 ${className}`} data-testid="language-switcher">
      <Globe className="w-4 h-4 text-slate-400" />
      <button
        type="button"
        onClick={() => change("en")}
        data-testid="lang-en"
        title={t("common.english")}
        className={`px-2 py-1 rounded-md text-xs font-semibold transition-colors ${
          current === "en"
            ? "bg-slate-900 text-white"
            : "text-slate-600 hover:bg-slate-100"
        }`}
      >
        EN
      </button>
      <button
        type="button"
        onClick={() => change("de")}
        data-testid="lang-de"
        title={t("common.german")}
        className={`px-2 py-1 rounded-md text-xs font-semibold transition-colors ${
          current === "de"
            ? "bg-slate-900 text-white"
            : "text-slate-600 hover:bg-slate-100"
        }`}
      >
        DE
      </button>
    </div>
  );
}
